import { Text } from "@marketplace/ui";
import { cva } from "class-variance-authority";

type ClaimStatusPillProps = {
  status: string;
  label: string;
  onClick?: () => void;
};

const claimStatusPill = cva(
  "flex justify-center items-center w-[148px] h-6 rounded",
  {
    variants: {
      status: {
        review: "bg-[#FEFFDE] text-[#929618]",
        reject: "bg-[#FFE7E7] text-[#8B1515]",
        approve: "bg-[#EFF3FF] text-[#0648FF]",
        payment_success: "bg-[#E5FFDE] text-[#45B527]",
        on_verification: "bg-[#FFF9E5] text-[#BD940A]"
      },
      clickable: {
        true: "cursor-pointer hover:opacity-80 transition-opacity",
        false: ""
      }
    },
    defaultVariants: {
      clickable: false
    }
  }
);

export const ClaimStatusPill = ({
  status,
  label,
  onClick
}: ClaimStatusPillProps) => (
  <div
    className={claimStatusPill({
      status: status as
        | "review"
        | "reject"
        | "approve"
        | "payment_success"
        | "on_verification",
      clickable: !!onClick,
      className: ![
        "review",
        "reject",
        "approve",
        "payment_success",
        "on_verification"
      ].includes(status)
        ? "bg-mischka-100 text-fjord-grey-500"
        : undefined
    })}
    onClick={onClick}
  >
    <Text>{label}</Text>
  </div>
);
